import { Box } from "@mui/material";
import { type FC } from "react";
import { PaginationWrapper } from "../generic/components/pagination-wrapper";
import { AssetCard } from "./asset-card";
import type { Asset } from "./server/digital-asset-service";
import type { Folder } from "./server/folder-service";
import { FolderCard } from "./folder-card";

export const AssetGrid: FC<{
  assets: Asset[];
  designer?: string | null;
  onClick?: (asset: Asset) => void;
  folders?: Folder[];
  showFolders?: boolean;
}> = ({ assets, designer, onClick, folders, showFolders = true }) => {
  return (
    <PaginationWrapper
      data={assets}
      itemsPerPage={25}
      renderPage={(data) => (
        <Box display="grid" gap={4} gridTemplateColumns="repeat(auto-fit, minmax(200px, 305px))">
          {showFolders && folders?.map((folder) => <FolderCard key={folder.id} folder={folder} />)}
          {data.map((asset) => (
            <AssetCard
              key={asset.id}
              asset={asset}
              data-testid="asset"
              onClick={() => onClick?.(asset)}
              designer={designer}
            />
          ))}
        </Box>
      )}
    />
  );
};
